module.exports = __webpack_public_path__ + "img/yklogo.34eb6bed.png";